
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Events",
      function () {
        return require("private-next-pages/ShuffleMaps/Events.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Events"])
      });
    }
  